import { MetadataStorage } from './MetadataStorage';
import { getGlobal } from './utils';
var globalScope = getGlobal();
/**
 * Default metadata storage is used as singleton and can be used to storage all metadatas.
 */
if (!globalScope.classTransformerMetadataStorage) {
    globalScope.classTransformerMetadataStorage = new MetadataStorage();
}
export var defaultMetadataStorage = globalScope.classTransformerMetadataStorage;
//# sourceMappingURL=storage.js.map